import { Label, Shimmer } from '@components/index';
import {
  Bottom,
  DescriptionSection,
  Grid,
  InfoContainer,
  ProductSpecContainer,
  Row,
  SearchSection,
} from './ProductMatchDetailsDialog.styles';

export const ProductMatchDetailsLoading = () => {
  return (
    <>
      <Row>
        <Shimmer
          style={{ height: 130, width: 130, borderRadius: 4 }}
          primary="#f1f1f1"
          secondary="#ececec"
        />
        <Grid>
          <InfoContainer>
            <Label>Product Name</Label>
            <Shimmer
              style={{ height: 16, width: 100, borderRadius: 4 }}
              primary="#f1f1f1"
              secondary="#ececec"
            />
          </InfoContainer>
          <InfoContainer>
            <Label>Manufacturer</Label>
            <Shimmer
              style={{ height: 16, width: 100, borderRadius: 4 }}
              primary="#f1f1f1"
              secondary="#ececec"
            />
          </InfoContainer>
          <InfoContainer>
            <Label>Category</Label>
            <Shimmer
              style={{ height: 16, width: 100, borderRadius: 4 }}
              primary="#f1f1f1"
              secondary="#ececec"
            />
          </InfoContainer>
          <InfoContainer>
            <Label>Model #</Label>
            <Shimmer
              style={{ height: 16, width: 100, borderRadius: 4 }}
              primary="#f1f1f1"
              secondary="#ececec"
            />
          </InfoContainer>
          <InfoContainer>
            <Label>Product Page</Label>
            <Shimmer
              style={{ height: 16, width: 100, borderRadius: 4 }}
              primary="#f1f1f1"
              secondary="#ececec"
            />
          </InfoContainer>
          <InfoContainer>
            <Label>Product Lifecycle</Label>
            <Shimmer
              style={{ height: 16, width: 100, borderRadius: 4 }}
              primary="#f1f1f1"
              secondary="#ececec"
            />
          </InfoContainer>
        </Grid>
      </Row>

      <Bottom>
        <DescriptionSection>
          <Label>Description</Label>
          <Shimmer
            style={{ height: 26, width: '100%', borderRadius: 4 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />
        </DescriptionSection>
        <SearchSection>
          <Label>Product Specs</Label>
          <ProductSpecContainer className="bscroll">
            <Shimmer
              style={{ height: 16, width: '100%', borderRadius: 4 }}
              primary="#f1f1f1"
              secondary="#ececec"
            />
            <Shimmer
              style={{
                height: 16,
                width: '100%',
                borderRadius: 4,
                marginTop: 8,
              }}
              primary="#f1f1f1"
              secondary="#ececec"
            />
            <Shimmer
              style={{
                height: 16,
                width: '100%',
                borderRadius: 4,
                marginTop: 8,
              }}
              primary="#f1f1f1"
              secondary="#ececec"
            />
          </ProductSpecContainer>
        </SearchSection>
      </Bottom>
    </>
  );
};
